import { customFetchOptions, throwErrorWhenFetchError } from "@refere/ui-utils/ui/utils/fetch";

/**
 * Empacota a chamada para fetch, usando a biblioteca do refere-ui-utils. 
 * - Trata o fetch para ter valores default de método e header em caso de ter algum body
 * - Ele dispara erro de javascript em caso de erro vindo no fetch, especialmente útil para tratamento de erros por alguma ferramentas, como swr
 * @param input 
 * @param init 
 * @param options 
 * @returns 
 */
export async function fetchWrapper<T>(
    input: string, 
    init?: RequestInit,
    options?: customFetchOptions) : Promise<T> {

    const _init = {
        method: "GET",
        ...(init ?? { })
    } as RequestInit;

    // Se o método for PUT ou POST é necessário um header de conteúdo
    if (_init.method === "PUT" || _init.method === "POST") {
        _init.headers = { 
            'Content-type': 'application/json; charset=UTF-8', 
            ...(init.headers ?? { })
        };
    }

    return throwErrorWhenFetchError<T>(input, _init, options);
}